import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "./push_notifications"

// Handle "Today" button click to scroll to current day
document.addEventListener('DOMContentLoaded', function() {
  setupTodayButtonScrolling();
  setupCalendarStyling();
  // Only scroll on initial load if Today button was clicked
  if (shouldScrollToToday()) {
    setTimeout(scrollToToday, 200);
  }
});

document.addEventListener('turbo:load', function() {
  setupTodayButtonScrolling();
  setupCalendarStyling();
  // Only scroll after navigation if Today button was clicked
  if (shouldScrollToToday()) {
    setTimeout(scrollToToday, 200);
  }
});

document.addEventListener('turbo:render', function() {
  setupCalendarStyling();
  // Only scroll after render if Today button was clicked
  if (shouldScrollToToday()) {
    setTimeout(scrollToToday, 300);
  }
});

function setupTodayButtonScrolling() {
  const todayButton = document.querySelector('.btn-primary');
  if (todayButton && todayButton.textContent.trim() === 'Today') {
    console.log('Found Today button:', todayButton);
    
    // Remove existing event listeners by cloning
    const newButton = todayButton.cloneNode(true);
    todayButton.parentNode.replaceChild(newButton, todayButton);
    
    newButton.addEventListener('click', function(e) {
      console.log('Today button clicked');
      // Mark that we should scroll to today after navigation
      sessionStorage.setItem('scrollToToday', 'true');
    });
  }
}

function shouldScrollToToday() {
  const shouldScroll = sessionStorage.getItem('scrollToToday') === 'true';
  if (shouldScroll) {
    sessionStorage.removeItem('scrollToToday');
  }
  return shouldScroll;
}

function setupCalendarStyling() {
  console.log('Setting up calendar styling...');
  
  // Get today's date in the user's local timezone
  const today = new Date();
  const todayString = today.getFullYear() + '-' + 
                     String(today.getMonth() + 1).padStart(2, '0') + '-' + 
                     String(today.getDate()).padStart(2, '0');
  
  console.log('Browser local date:', todayString);
  
  // Find all calendar days and apply appropriate classes to parent day elements
  const calendarDays = document.querySelectorAll('.calendar-day');
  
  calendarDays.forEach(calendarDay => {
    const parentDay = calendarDay.closest('.day');
    if (parentDay) {
      const isOtherMonth = calendarDay.dataset.otherMonth === 'true';
      
      if (isOtherMonth) {
        parentDay.classList.add('other-month');
        parentDay.classList.remove('current-month');
      } else {
        parentDay.classList.add('current-month');
        parentDay.classList.remove('other-month');
      }
    }
    
    // Update "today" highlighting based on browser's local date
    const dateNumber = calendarDay.querySelector('.date-number');
    if (dateNumber && dateNumber.dataset.date === todayString) {
      dateNumber.classList.add('today');
      const parentDay = calendarDay.closest('.day');
      if (parentDay) {
        parentDay.classList.add('today');
      }
    } else if (dateNumber) {
      dateNumber.classList.remove('today');
      const parentDay = calendarDay.closest('.day');
      if (parentDay) {
        parentDay.classList.remove('today');
      }
    }
  });
  
  console.log('Calendar styling setup complete');
}

function scrollToToday() {
  console.log('Attempting to scroll to today...');
  const todayElement = document.querySelector('.date-number.today');
  console.log('Today element found:', todayElement);
  
  if (todayElement) {
    const calendarDay = todayElement.closest('.day');
    console.log('Calendar day found:', calendarDay);
    
    if (calendarDay) {
      console.log('Scrolling to today...');
      calendarDay.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  } else {
    console.log('Today element not found - might not be current month');
  }
}

// Chore assignment interactions
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, setting up chore interactions');
  setupChoreInteractions();
});

document.addEventListener('turbo:load', function() {
  console.log('Turbo loaded, setting up chore interactions');
  setupChoreInteractions();
});

document.addEventListener('turbo:render', function() {
  console.log('Turbo rendered, re-setting up chore interactions');
  setupChoreInteractions();
});

function setupChoreInteractions() {
  console.log('setupChoreInteractions called');
  
  const choreItems = document.querySelectorAll('.chore-item');
  console.log('Found chore items:', choreItems.length);
  
  if (choreItems.length === 0) {
    console.log('No chore items found. Calendar might not be loaded yet.');
    return;
  }
  
  choreItems.forEach((item, index) => {
    console.log('Setting up listener for item', index, item.dataset);
    
    // Remove existing event listeners by cloning
    const newItem = item.cloneNode(true);
    item.parentNode.replaceChild(newItem, item);
    
    // Set up click listener
    newItem.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Chore item clicked:', this);
      console.log('Classes:', this.className);
      console.log('Dataset:', this.dataset);
      
      const choreId = this.dataset.choreId;
      const assignmentId = this.dataset.assignmentId;
      const calendarDay = this.closest('.calendar-day');
      const date = calendarDay ? calendarDay.dataset.date : null;
      const isAssignedToCurrentUser = this.dataset.assignedToCurrentUser === 'true';
      const canUnassign = this.dataset.canUnassign === 'true';
      const canComplete = this.dataset.canComplete === 'true';
      const isCompleted = this.dataset.completed === 'true';
      const isAvailable = this.classList.contains('available');

      console.log('Click data:', {
        choreId,
        assignmentId,
        date,
        isAssignedToCurrentUser,
        canUnassign,
        canComplete,
        isCompleted,
        isAvailable,
        calendarDay: calendarDay ? 'found' : 'not found'
      });

      if (isAvailable && choreId && date) {
        console.log('Assigning chore...');
        assignChore(choreId, date, this);
      } else if (isAssignedToCurrentUser && canUnassign && assignmentId) {
        // User's own chore - allow unassign, not complete
        console.log('Unassigning own chore...');
        if (confirm('Do you want to remove yourself from this chore?')) {
          unassignChore(assignmentId, this);
        }
      } else if (canComplete && assignmentId && !isCompleted && !isAssignedToCurrentUser) {
        // Someone else's chore - allow complete
        console.log('Completing chore...');
        const choreName = this.querySelector('.chore-name').textContent;
        const userName = this.querySelector('.user-name').textContent;
        showCompletionModal(assignmentId, choreName, userName, date, this);
      } else if (canComplete && assignmentId && isCompleted && !isAssignedToCurrentUser) {
        // Someone else's completed chore - allow uncomplete
        console.log('Uncompleting chore...');
        if (confirm('Mark this chore as incomplete?')) {
          uncompleteChore(assignmentId, this);
        }
      } else if (canUnassign && assignmentId && !isAssignedToCurrentUser) {
        // Admin unassigning someone else's chore
        console.log('Unassigning chore (admin)...');
        if (confirm('Do you want to unassign this chore? (Admin action)')) {
          unassignChore(assignmentId, this);
        }
      } else {
        console.log('No action taken. Available:', isAvailable, 'CanUnassign:', canUnassign, 'CanComplete:', canComplete, 'IsCurrentUser:', isAssignedToCurrentUser);
      }
    });
    
    // Add hover effects
    newItem.addEventListener('mouseenter', function() {
      console.log('Mouse entered chore item:', this.querySelector('.chore-name').textContent);
      this.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    });
    
    newItem.addEventListener('mouseleave', function() {
      this.style.boxShadow = '';
    });
  });
  
  // Also add hover effect to calendar days
  const calendarDays = document.querySelectorAll('.calendar-day');
  calendarDays.forEach(day => {
    day.addEventListener('mouseenter', function() {
      this.closest('.day').style.borderColor = '#007bff';
    });
    
    day.addEventListener('mouseleave', function() {
      this.closest('.day').style.borderColor = '#dee2e6';
    });
  });
}

function assignChore(choreId, date, element) {
  // Add loading state
  element.style.opacity = '0.6';
  element.style.pointerEvents = 'none';
  
  fetch('/chore_assignments/assign', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({
      chore_id: choreId,
      date: date
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // Add animation class
      element.classList.add('changing');
      
      // Update the UI after a brief delay for animation
      setTimeout(() => {
        element.classList.remove('available');
        element.classList.add('assigned');
        element.dataset.assignmentId = data.assignment_id;
        element.dataset.assignedToCurrentUser = 'true';
        element.dataset.canUnassign = 'true';
        element.dataset.userColor = data.user_color;

        // Apply user color to background and border with !important
        element.style.setProperty('background-color', data.user_color, 'important');
        element.style.setProperty('border-color', data.user_color, 'important');

        const statusSpan = element.querySelector('.assignment-status');
        statusSpan.innerHTML = '<span class="user-name">' + data.user_name + '</span>';

        // Remove animation class and reset opacity
        element.classList.remove('changing');
        element.style.opacity = '1';
        element.style.pointerEvents = 'auto';
      }, 250);
    } else {
      alert(data.message || 'Failed to assign chore');
      element.style.opacity = '1';
      element.style.pointerEvents = 'auto';
    }
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Failed to assign chore');
    element.style.opacity = '1';
    element.style.pointerEvents = 'auto';
  });
}

function unassignChore(assignmentId, element) {
  // Add loading state
  element.style.opacity = '0.6';
  element.style.pointerEvents = 'none';
  
  fetch('/chore_assignments/' + assignmentId + '/unassign', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // Add animation class
      element.classList.add('changing');
      
      // Update the UI after a brief delay for animation
      setTimeout(() => {
        element.classList.remove('assigned');
        element.classList.add('available');
        element.dataset.assignmentId = '';
        element.dataset.assignedToCurrentUser = 'false';
        element.dataset.canUnassign = 'false';
        element.dataset.userColor = '';

        // Reset background and border to default
        element.style.backgroundColor = '';
        element.style.borderColor = '';

        const statusSpan = element.querySelector('.assignment-status');
        statusSpan.innerHTML = '<span class="available-text">Available</span>';

        // Remove animation class and reset opacity
        element.classList.remove('changing');
        element.style.opacity = '1';
        element.style.pointerEvents = 'auto';
      }, 250);
    } else {
      alert(data.message || 'Failed to unassign chore');
      element.style.opacity = '1';
      element.style.pointerEvents = 'auto';
    }
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Failed to unassign chore');
    element.style.opacity = '1';
    element.style.pointerEvents = 'auto';
  });
}

// Modal functions
let currentCompletionData = null;

window.showCompletionModal = function(assignmentId, choreName, userName, date, element) {
  const modal = document.getElementById('completionModal');
  const title = document.getElementById('completionModalTitle');
  const message = document.getElementById('completionModalMessage');
  const confirmBtn = document.getElementById('confirmCompletionBtn');

  // Determine if it's today or yesterday
  const choreDate = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const isToday = choreDate.getTime() === today.getTime();
  const dateText = isToday ? 'today' : 'yesterday';

  title.textContent = `Check off ${choreName}?`;
  message.textContent = `Mark ${choreName} as completed for ${userName} ${dateText}?`;

  currentCompletionData = { assignmentId, element };

  modal.classList.add('show');

  // Set up confirm button
  confirmBtn.onclick = function() {
    completeChore(currentCompletionData.assignmentId, currentCompletionData.element);
    closeCompletionModal();
  };
};

window.closeCompletionModal = function() {
  const modal = document.getElementById('completionModal');
  modal.classList.remove('show');
  currentCompletionData = null;
};

// Close modal when clicking outside
document.addEventListener('click', function(e) {
  const modal = document.getElementById('completionModal');
  if (e.target === modal) {
    closeCompletionModal();
  }
});

// Completion functions
function completeChore(assignmentId, element) {
  console.log('Completing chore:', assignmentId);

  element.style.opacity = '0.5';
  element.style.pointerEvents = 'none';

  fetch(`/chore_assignments/${assignmentId}/complete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      setTimeout(() => {
        element.classList.add('completed');
        element.dataset.completed = 'true';

        // Add checkmark
        const statusSpan = element.querySelector('.assignment-status');
        const userName = element.querySelector('.user-name');
        if (userName && !statusSpan.querySelector('.completion-checkmark')) {
          const checkmark = document.createElement('span');
          checkmark.className = 'completion-checkmark';
          checkmark.textContent = '✓';
          statusSpan.appendChild(checkmark);
        }

        element.classList.remove('changing');
        element.style.opacity = '1';
        element.style.pointerEvents = 'auto';
      }, 250);
    } else {
      alert(data.message || 'Failed to complete chore');
      element.style.opacity = '1';
      element.style.pointerEvents = 'auto';
    }
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Failed to complete chore');
    element.style.opacity = '1';
    element.style.pointerEvents = 'auto';
  });
}

function uncompleteChore(assignmentId, element) {
  console.log('Uncompleting chore:', assignmentId);

  element.style.opacity = '0.5';
  element.style.pointerEvents = 'none';

  fetch(`/chore_assignments/${assignmentId}/uncomplete`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      setTimeout(() => {
        element.classList.remove('completed');
        element.dataset.completed = 'false';

        // Remove checkmark
        const checkmark = element.querySelector('.completion-checkmark');
        if (checkmark) {
          checkmark.remove();
        }

        element.classList.remove('changing');
        element.style.opacity = '1';
        element.style.pointerEvents = 'auto';
      }, 250);
    } else {
      alert(data.message || 'Failed to uncomplete chore');
      element.style.opacity = '1';
      element.style.pointerEvents = 'auto';
    }
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Failed to uncomplete chore');
    element.style.opacity = '1';
    element.style.pointerEvents = 'auto';
  });
}

import "./channels"
